import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";


const steps = [
  {
    number: "1",
    title: "Upload Photo",
    description: "Upload any image from your device",
  },
  {
    number: "2",
    title: "Add Text",
    description: "Add and style your text layers elements",
  },
  {
    number: "3",
    title: "Position Text",
    description: "Place text behind image elements",
  },
  {
    number: "4",
    title: "Download",
    description: "Export in high quality PNG format",
  },
];

const FourStepDesign = () => {
  return (
    <div className="relative overflow-hidden py-6 px-4 mt-8">
      {/* Gradient background blobs */}
      <div className="absolute top-[-200px] left-[-150px] w-[400px] h-[400px] opacity-30 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-[-200px] right-[-150px] w-[400px] h-[400px] opacity-30 rounded-full blur-3xl animate-pulse"></div>

      {/* Heading */}
      <h2 className="text-left md:text-center text-[#242424] text-4xl md:text-6xl font-extrabold mb-16 font-poppins ">
        Create Your Design in{" "}
        <span className="bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 text-transparent bg-clip-text animate-gradient">
          4 Simple Steps
        </span>
      </h2>

      {/* Steps grid */}
      <div className="max-w-7xl mx-auto w-full">
        <div className="block md:hidden">
          <Swiper
            modules={[Pagination]}
            spaceBetween={20}
            slidesPerView={1}
            pagination={{ clickable: true }}
          >
            {steps.map((step) => (
              <SwiperSlide key={step.number}>
                <div className="relative bg-white/10 border border-white/20 backdrop-blur-xl md:rounded-3xl p-8 flex flex-col items-center text-center shadow-2xl hover:scale-105 hover:shadow-[0_0_40px_rgba(255,255,255,0.2)] transition-all duration-500 ease-in-out">
                  {/* Glow ring behind badge */}
                  <div className="absolute top-2 left-1/2 -translate-x-1/2 w-24 h-24 rounded-full bg-gradient-to-tr from-purple-400 to-blue-400 opacity-20 blur-2xl"></div>

                  {/* Number badge */}
                  <div className="relative z-10 bg-gradient-to-br from-pink-400 via-[#645ade] to-[#645ade] text-white rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold shadow-lg">
                    {step.number}
                  </div>

                  {/* Title */}
                  <h3 className="mt-6 text-xl md:text-2xl font-bold text-[#242424]">
                    {step.title}
                  </h3>

                  {/* Description */}
                  <p className="mt-3 text-[#525151] text-sm md:text-base max-w-[200px]">
                    {step.description}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* DESKTOP GRID */}
        <div className="hidden md:grid grid-cols-2 md:grid-cols-4 gap-10">
          {steps.map((step) => (
            <div
              key={step.number}
              className="relative bg-white/10 border border-white/20 backdrop-blur-xl rounded-3xl p-8 flex flex-col items-center text-center shadow-2xl hover:scale-105 hover:shadow-[0_0_40px_rgba(255,255,255,0.2)] transition-all duration-500 ease-in-out"
            >
              {/* Glow ring behind badge */}
              <div className="absolute top-2 left-1/2 -translate-x-1/2 w-24 h-24 rounded-full bg-gradient-to-tr from-purple-400 to-blue-400 opacity-20 blur-2xl"></div>

              {/* Number badge */}
              <div className="relative z-10 bg-gradient-to-br from-pink-400 via-[#645ade] to-[#645ade] text-white rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold shadow-lg">
                {step.number}
              </div>

              {/* Title */}
              <h3 className="mt-6 text-xl md:text-2xl font-bold text-[#242424]">
                {step.title}
              </h3>

              {/* Description */}
              <p className="mt-3 text-[#525151] text-sm md:text-base max-w-[200px]">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FourStepDesign;
